import { ErrorMessage } from 'formik'

const Error = ({ fieldName }) => (
  <div className="text-red">
    <ErrorMessage name={fieldName} />
  </div>
)

export default Error
